import SvgIcon from '@material-ui/core/SvgIcon';

export default function UnPin(props:any) {
  return (
    <SvgIcon viewBox='0 0 19 21' { ...props}>
    <path d="M6.66211 4.9998V2.7998H5.66211V0.799805H15.6621V2.7998H14.6621V10.7998L16.6621 12.7998V14.7998H16.4621L12.6621 10.9998V2.7998H8.66211V6.9998L6.66211 4.9998ZM18.6621 19.4998L17.3621 20.7998L11.4621 14.8998V20.7998H9.86211V14.7998H4.66211V12.7998L6.66211 10.7998V10.0998L0.662109 4.0998L1.96211 2.7998L18.6621 19.4998ZM7.46211 12.7998H9.26211L8.36211 11.8998L7.46211 12.7998Z" fill="currentColor"/>
    </SvgIcon>
  );
}